import { Link } from 'react-router'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

export default function NotFound() {
    const { t } = useTranslation()
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="min-h-screen bg-white flex items-center justify-center"
        >
            <title>{t('notFound.metaTitle')}</title>
            <meta name="description" content={t('notFound.metaDescription')} />
            <meta name="robots" content="noindex" />
            <div className="text-center space-y-6 px-4">
                <p className="text-8xl font-bold text-navy">404</p>
                <h1 className="text-2xl font-bold text-slate-900">{t('notFound.title')}</h1>
                <p className="text-slate-600">{t('notFound.body')}</p>
                <Link
                    to="/"
                    className="inline-block bg-navy hover:bg-navy-dark text-white font-bold py-3 px-8 rounded-xl transition-colors"
                >
                    {t('notFound.back')}
                </Link>
            </div>
        </motion.div>
    )
}
